import '../../constants/index.mjs';
import { componentSizeMap } from '../../constants/size.mjs';

const getComponentSize = (size) => {
  return componentSizeMap[size || "default"];
};

export { getComponentSize };
//# sourceMappingURL=size.mjs.map
